Vue.component("conference", {
    mixins: [SceneContentComponentMixin],
    template: `
        <transition name="fadeinvideo">
            <div class="conference__wrapper" v-if="videoplayerready" :class="{'conference__wrapper--nochat': chatlink === ''}">
                <button class="conference__closebutton" @click="close">
                    <img src="assets/img/ui/close-white.svg">
                </button>

                <iframe class="conference__conference"
                    :src="streamlink"
                    mozallowfullscreen="1" 
                    webkitallowfullscreen="1" 
                    allowfullscreen="1" 
                    allow="autoplay; fullscreen"
                    scrolling="no">
                </iframe>

                <iframe class="conference__chat"
                    v-if="chatlink !== ''"
                    :src="chatlink"
                    ref="iframeChat"
                    scrolling="no">

                </iframe>

                <aside class="conference__title__wrapper">
                    <h3 v-html="title"></h3>
                    <h4 v-html="subtitle"></h4>
                </aside>
            </div>
        </transition>
    `,
    data() {
        return {
            // manifest values
            streamlink: '',
            chatlink: '',
            title: '',
            subtitle: '',

            chatstyle: null,

            // Variables for this instance
            videoplayerready: false
        }
    },
    methods: {
    },
    mounted() {
        // handle intro animation
        this.videoplayerready = true;
    },
})

touchKit.ComponentManager.register("conference", {
    singleton: true
});